import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

import { IBMSCommonStepperData } from '../bms-common-stepper.component';

@Component({
  selector: 'bms-common-stepper-horizontal',
  templateUrl: './bms-common-stepper-horizontal.component.html',
  styleUrls: ['./bms-common-stepper-horizontal.component.scss'],
})
export class BMSCommonStepperHorizontalComponent {
  @ViewChild('stepper') stepper: MatStepper;

  @Output() onStepperClick: EventEmitter<StepperSelectionEvent> =
    new EventEmitter();
  @Input() stepperData: IBMSCommonStepperData[] = [];

  onStepChange(e: StepperSelectionEvent) {
    this.onStepperClick.emit(e);
  }

  goToPreviousStep() {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.previous();
    }
  }

  goToNextStep() {
    this.stepper.next();
  }
}
